import { configureStore } from "@reduxjs/toolkit";
import vendorAuthReducer from "./slices/vendorAuthSlice";
import vendorRegisterReducer from "./slices/vendorRegisterSlice";
import vendorFormReducer from "./slices/vendorFormSlice";
import vendorProfileReducer from "./slices/vendorProfileSlice";
import vendorJobReducer from "./slices/vendorJobSlice";
import vendorPaymentReducer from "./slices/vendorPaymentSlice";
import vendorDashboardReducer from "./slices/vendorDashboardSlice";
import vendorClusterSliceReducer from "./slices/vendorClusterSlice";

export const vendorStore = configureStore({
  reducer: {
    vendorAuth: vendorAuthReducer,
    vendorRegister: vendorRegisterReducer,
    vendorForm: vendorFormReducer,
    vendorProfile: vendorProfileReducer,
    vendorJob: vendorJobReducer,
    vendorPayment: vendorPaymentReducer,
    vendorDashboard: vendorDashboardReducer,
    vendorCluster: vendorClusterSliceReducer,
  },
});

export default vendorStore;
